import {
	decodeReportId as decodeReportIdImpl,
	encodeReportId as encodeReportIdImpl,
} from '@framework/analytics/utils/report-id-encoding.util';

export class JeptoAnalyticsUtil {
	/**
	 * Decodes a report ID into account ID and view ID components
	 * @param encoded - The encoded report ID string
	 * @returns Object containing accountId and viewId
	 */
	static decodeReportId(encoded: string): { accountId: string; viewId: string } {
		return decodeReportIdImpl(encoded);
	}

	/**
	 * Encodes account and view hex ids into the Crockford Base32 report path segment (`/:reportId`).
	 */
	static encodeReportId(
		accountId: string,
		viewId: string
	): string {
		return encodeReportIdImpl(accountId, viewId);
	}

	/**
	 * Changes the application favicon dynamically
	 *
	 * This method updates the favicon link element in the document head
	 * to display a custom logo specified by URL. Useful for white-labeling
	 * or customizing the application appearance for different environments.
	 *
	 * @param logoUrl - The URL of the image to use as the new favicon
	 */
	static changeAppLogo(logoUrl: string): void {
		const logoElement = document.querySelector('link[rel="icon"]');
		if (logoElement) {
			(logoElement as HTMLLinkElement).href = logoUrl;
		}
	}
}
